import { render, staticRenderFns } from "./LoadDetailSkeletonResponsive.vue?vue&type=template&id=55f9414b&scoped=true"
import script from "./LoadDetailSkeletonResponsive.vue?vue&type=script&lang=js"
export * from "./LoadDetailSkeletonResponsive.vue?vue&type=script&lang=js"
import style0 from "./LoadDetailSkeletonResponsive.vue?vue&type=style&index=0&id=55f9414b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f9414b",
  null
  
)

export default component.exports